import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import avatarImage from "../Assets/profilePhoto.jpg";
import balanceIcon from "../Assets/balanceIcon.png";
import luanchIcon from "../Assets/launchIcon2.png";
import appHistoryIcon from "../Assets/appHistoryIcon.png";
import dailyIcon from "../Assets/dailyIcon.png";
import Footer from "../Components/Footer";
import starting from "../Api/starting";
import profile from '../Api/profile';
import Swal from "sweetalert2";
import Logo from "../Assets/logo.png";
import Copyright_Footer from "../Components/copyrightFooter";
import ModelLaunch from "../Components/ModelLaunch";

export default function Starting() {
  const navigate = useNavigate();
  const [startingData, setStartingData] = useState(null);
  const [userData, setUserData] = useState(null);
  const [showSurveyModal, setShowSurveyModal] = useState(false);

  const Toast = Swal.mixin({
    toast: true,
    position: 'bottom-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer)
      toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
  })

  const handleToSurvey = () => {
    openLaunchModal()
  };

  const handleToAppHistory = () => {
    navigate("/transaction_history");
  };

  const fetchStartingInfo = async () => {
    try {
      const response = await starting();
      setStartingData(response.data);
    } catch (error) {
      console.error("API Error:", error.message);
      if (error.response?.status === 401) {
        Toast.fire({
          icon: 'error',
          title: error.response.data.title
        })
        localStorage.clear();
        navigate("/");
      }
      Toast.fire({
        icon: 'error',
        title: error.response.data.message
      })
    }
  };

  const fetchUserInfo = async () => {
    try {
      const response = await profile();
      setUserData(response.data);
    } catch (error) {
      console.error("API Error:", error.message);
      Toast.fire({
        icon: 'error',
        title: error.response.data.message
      })
    }
  };

  useEffect(() => {
    fetchStartingInfo();
    fetchUserInfo();
  }, []);


  const openLaunchModal = () => {
    setShowSurveyModal(true);
  };

  const closeLaunchModal = () => {
    setShowSurveyModal(false);
    fetchStartingInfo();
    fetchUserInfo();
  };

  return (
    <>
      <div className="container mobile-page">
        {/*<Back />*/}
        <div className="mt-8 starting-profile">
          <div className="row">
            <div className="col-9">
              <img src={Logo} alt="Logo" className='my-3' width={150}/>
            </div>
            <div className="col-3 d-flex justify-content-end">
              <div className="starting-profile-image ">
                <img src={userData?.profilePicture ? userData?.profilePicture : avatarImage} alt="User Profile Image" className='border border-3 text-white' />
              </div>
            </div>
          </div>
        </div>

        <div className="starting-background mb-4" style={{ height: '350px' }}></div>

        <div className="d-flex justify-content-center">
          <button className="starting-btn px-1 py-2 rounded-3 fs-4 fw-bold" onClick={handleToSurvey}>Start</button>
        </div>

        <div className="mt-4">
          <div className="mb-4 fs-4 fw-bold text-center text-white">{userData?.vipLevel}</div>
          <div className="d-flex justify-content-around">
            <div className=" col-6 d-flex p-1 py-3 align-items-center justify-content-evenly content-section rounded-4 deepBlack " onClick={handleToAppHistory} style={{ width: '47%', boxShadow: 'box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.8)' }}>
              <div className="starting-icon text-center">
                <img src={appHistoryIcon}  width={50} alt='appHistoryIcon'/>
              </div>
              <div className="starting-title">Apps History</div>
            </div>
            <div className="col-6 d-flex p-1 py-3 align-items-center justify-content-evenly content-section rounded-4" style={{ width: '47%', boxShadow: 'box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.8)', background:'#2e2e2e' }}>
              <div className="starting-icon text-center">
                <img src={luanchIcon} width={100} alt='luanchIcon'/>
              </div>
              <div className="starting-title ml-5">Launch ({startingData?.tradeBalance}/{startingData?.totalTrade})</div>
            </div>
          </div>
        </div>

        <div className="container mt-4">
          <div className="row">
            <div className="col-2">
              <img src={dailyIcon} width={50} alt='dailyIcon'/>
            </div>
            <div className="col-10 d-flex flex-column">
              <span className='text-pink h6'>Daily Earning</span>
              <span className='fw-bold text-white h4'>USDT {startingData?.dailyProfit}</span>
            </div>
            <div className="col-12 my-1">
              <span className='lightGrey h6 survey-tickbox'>The system will automatic update the daily profit.</span>
            </div>
          </div>

          <div className="row my-3">
            <div className="col-2">
              <img src={balanceIcon} width={50} alt='balanceIcon'/>
            </div>
            <div className="col-10 d-flex flex-column">
              <span className='text-pink h6'>Total Balance</span>
              <span className='fw-bold text-white h4'>USDT {startingData?.assetBalance}</span>
            </div>
            <div className="col-12 my-1">
              <span className='lightGrey h6 survey-tickbox'>The profit of each software will be added to the total balance.</span>
            </div>
          </div>
        </div>

        {/*<div className="starting-tab mt-4 mb-5 p-4 rounded-4 text-white">*/}
        {/*  <div className="d-flex">*/}
        {/*    <div className="starting-main-icon me-4 pt-2">*/}
        {/*      <img src={dailyEarningIcon} />*/}
        {/*    </div>*/}
        {/*    <div className="text-white">*/}
        {/*      <p style={{ float: 'right' }}>{startingData?.dailyProfit}</p>*/}
        {/*      <p>Daily Earning</p>*/}
        {/*      <span>The system will automatic update the daily earnings.</span>*/}
        {/*    </div>*/}
        {/*  </div>*/}
        {/*  <div className="d-flex">*/}
        {/*    <div className="starting-main-icon me-4 pt-2">*/}
        {/*      <img src={totalBalanceIcon} />*/}
        {/*    </div>*/}
        {/*    <div className="text-white">*/}
        {/*      <p style={{ float: 'right' }}>{startingData?.assetBalance}</p>*/}
        {/*      <p>Total Balance</p>*/}
        {/*      <span>Profit from each apps will be added to the total balance.</span>*/}
        {/*    </div>*/}
        {/*  </div>*/}
        {/*</div>*/}

        {/*<div className="mt-4 text-center text-white">*/}
        {/*  <p className="starting-hint fw-bold">{startingData?.hintTitle}</p>*/}
        {/*  <p className="starting-sub-hint">{startingData?.hintDescription}</p>*/}
        {/*</div>*/}
        {showSurveyModal && (
            <ModelLaunch onClose={closeLaunchModal}/>
        )}
        <Copyright_Footer/>
      </div>
      <Footer />
    </>
  );
}
